/**
 * @public
 * Scrolls to an HTML element
 *
 * @param {HTMLElement} element: the HTML element where to scroll to
 * @param {Number} spaceP: top space to add when scroll
 * @param {String} behaviorScrollP: scroll behavior
 * @return {void}
 */
function scrollToNative(element, spaceP, behaviorScrollP) {
  const space = spaceP || 0;
  const behaviorScroll = behaviorScrollP || 'smooth';
  const tabsCta = document.querySelector(element).offsetTop;
  const top = tabsCta + space;
  const behavior = ['auto', 'smooth'].includes(behaviorScroll)
    ? behaviorScroll
    : 'smooth';
  if (
    navigator.userAgent.indexOf('MSIE') !== -1 ||
    navigator.appVersion.indexOf('Trident/') > -1
  ) {
    window.scrollTo(0, tabsCta + space);
  } else {
    window.scrollTo({ top, behavior });
  }
}

export default scrollToNative;
